export const iconFontAwesomeMapsBook = (
	<i className="fa-solid fa-book"></i>
);
